import { useWindowWidth } from "~/utils/hooks/useWindowWidth";

const Listen = () => {
  const width = useWindowWidth();
  return (
    <section
      style={{
        backgroundImage:
          width > 768
            ? 'url("/img/listen.png")'
            : 'url("/img/listen_mobile.png")',
      }}
      className="max-md:min-h-[600px] max-md:bg-current max-md:py-16 py-64 mt-[-4px] min-h-screen relative bg-center bg-cover bg-no-repeat"
      id="listen"
    >
      <div className="absolute inset-0 max-md:bg-gradient-to-b max-md:from-[rgba(9,18,39,0.4)] max-md:via-[rgba(9,18,39,0.2)] max-md:to-[#091227] pointer-events-none" />
      <div className="container z-10">
        <div className="absolute bg-gradient-to-l from-[#091227] to-[#091227] w-full h-full left-0 top-0 opacity-40"></div>
        <div className="max-md:w-full w-[349px] relative z-10">
          <h2 className="max-lg:text-4xl max-lg:leading-[49px] text-center text-white text-5xl font-extrabold leading-[65px]">
            Listen without Limits
          </h2>

          <p className="max-lg:text-xl max-lg:leading-7 text-center text-white text-2xl font-light font tracking-tight mt-4">
            No credits. No coins. No limits. Listen as much as you want whenever
            you want.
          </p>
        </div>
      </div>
    </section>
  );
};

Listen.disolayName = "Listen";
export default Listen;
